import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Home() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const services = [
    {
      icon: 'ri-scales-3-line',
      title: 'Laundry Kiloan',
      description: 'Cuci bersih per kilogram dengan harga terjangkau',
      price: 'Mulai dari Rp 7.000/kg'
    },
    {
      icon: 'ri-shirt-line',
      title: 'Laundry Satuan',
      description: 'Perawatan khusus untuk pakaian premium Anda',
      price: 'Harga bervariasi'
    },
    {
      icon: 'ri-temp-hot-line',
      title: 'Cuci + Setrika',
      description: 'Pakaian bersih, wangi, dan rapi siap pakai',
      price: 'Paket lengkap'
    },
    {
      icon: 'ri-iron-line',
      title: 'Setrika Saja',
      description: 'Khusus untuk pakaian yang sudah bersih',
      price: 'Mulai dari Rp 5.000/kg'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Express Service',
      description: 'Layanan kilat untuk kebutuhan mendesak',
      price: 'Selesai dalam 24 jam'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Antar Jemput',
      description: 'Gratis antar jemput untuk area tertentu',
      price: 'Gratis untuk minimal 5kg'
    }
  ];

  const features = [
    {
      icon: 'ri-settings-5-line',
      title: 'Mesin Modern',
      description: 'Menggunakan mesin laundry terbaru dan deterjen berkualitas premium untuk hasil maksimal'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Proses Higienis',
      description: 'Standar kebersihan tinggi dengan proses pencucian yang higienis dan aman'
    },
    {
      icon: 'ri-time-line',
      title: 'Tepat Waktu',
      description: 'Kami komitmen mengembalikan cucian Anda sesuai waktu yang dijanjikan'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Harga Transparan',
      description: 'Tidak ada biaya tersembunyi, semua harga jelas dan kompetitif'
    }
  ];

  const testimonials = [
    {
      name: 'Ibu Siti Rahmawati',
      role: 'Ibu Rumah Tangga',
      comment: 'Pelayanan sangat memuaskan! Cucian bersih, wangi, dan rapi. Harga juga sangat terjangkau. Recommended banget!',
      rating: 5
    },
    {
      name: 'Bapak Ahmad Fauzi',
      role: 'Karyawan Swasta',
      comment: 'Express service-nya sangat membantu saat darurat. Selesai tepat waktu dan hasilnya memuaskan. Terima kasih YEZ Laundry!',
      rating: 5
    },
    {
      name: 'Dina Wijayanti',
      role: 'Mahasiswa',
      comment: 'Sudah langganan di sini hampir 2 tahun. Selalu puas dengan hasilnya. Harga pas di kantong mahasiswa!',
      rating: 5
    },
    {
      name: 'Rina Kusuma',
      role: 'Wiraswasta',
      comment: 'Layanan antar jemput sangat membantu! Tidak perlu repot keluar rumah. Cucian selalu bersih dan wangi.',
      rating: 5
    }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d5mp7i3lpot0rgnb7rbg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as Record<string, string>).toString()
      });

      if (response.ok) {
        setSubmitMessage('Terima kasih! Pesan Anda telah terkirim. Kami akan segera menghubungi Anda.');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      } else {
        setSubmitMessage('Maaf, terjadi kesalahan. Silakan coba lagi.');
      }
    } catch (error) {
      setSubmitMessage('Maaf, terjadi kesalahan. Silakan coba lagi.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/30eb194ee253a5c6b42a72982a10a01c.jpg" 
            alt="YEZ Laundry Hero"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-blue-900/70 via-blue-800/60 to-blue-900/70"></div>
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Solusi Laundry Bersih,<br />Wangi, dan Tepat Waktu
          </h1>
          <p className="text-lg md:text-xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
            Layanan laundry profesional dengan kualitas terbaik, proses cepat, dan harga yang terjangkau. Percayakan kebersihan pakaian Anda kepada kami!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/62895338139977?text=Halo%20YEZ%20Laundry%2C%20saya%20ingin%20memesan%20layanan%20laundry"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              Pesan Sekarang
            </a>
            <a
              href="tel:+62895338139977"
              className="bg-white text-blue-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              Hubungi Kami
            </a>
          </div>
        </div>

        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-3xl text-white/70"></i>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gradient-to-b from-white to-blue-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Layanan Kami</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Berbagai pilihan layanan laundry untuk memenuhi kebutuhan Anda
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200 group"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-50 rounded-xl mb-5 group-hover:bg-blue-100 transition-colors">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <div className="text-blue-600 font-semibold text-sm">{service.price}</div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/layanan"
              className="inline-flex items-center text-blue-600 font-semibold text-base hover:text-blue-700 transition-colors whitespace-nowrap"
            >
              Lihat Detail Layanan
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Keunggulan Kami</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Mengapa memilih YEZ Laundry untuk kebutuhan laundry Anda
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-2xl mx-auto mb-5">
                  <i className={`${feature.icon} text-3xl text-blue-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Testimoni Pelanggan</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Apa kata pelanggan setia kami tentang layanan YEZ Laundry
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-md border border-gray-100"
              >
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-base"></i>
                  ))}
                </div>
                <p className="text-sm text-gray-700 mb-5 leading-relaxed italic">"{testimonial.comment}"</p>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-xs text-gray-500">{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Hubungi Kami</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Ada pertanyaan atau ingin memesan layanan? Silakan isi form di bawah ini
            </p>
          </div>

          <form onSubmit={handleSubmit} data-readdy-form id="contact-form" className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 shadow-lg border border-blue-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Nama Lengkap *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  placeholder="Masukkan nama Anda"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  placeholder="email@example.com"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Nomor WhatsApp *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  placeholder="08123456789"
                />
              </div>
              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                  Layanan yang Diminati *
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                >
                  <option value="">Pilih layanan</option>
                  <option value="Laundry Kiloan">Laundry Kiloan</option>
                  <option value="Laundry Satuan">Laundry Satuan</option>
                  <option value="Cuci + Setrika">Cuci + Setrika</option>
                  <option value="Setrika Saja">Setrika Saja</option>
                  <option value="Express Service">Express Service</option>
                  <option value="Antar Jemput">Antar Jemput</option>
                </select>
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                Pesan atau Pertanyaan
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm resize-none"
                placeholder="Ceritakan kebutuhan laundry Anda..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 karakter</p>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-blue-600 text-white px-6 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isSubmitting ? 'Mengirim...' : 'Kirim Pesan'}
            </button>

            {submitMessage && (
              <div className={`mt-4 p-4 rounded-lg text-sm ${submitMessage.includes('Terima kasih') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Lokasi & Jam Operasional</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Kunjungi outlet kami atau hubungi untuk layanan antar jemput
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            <div className="bg-white rounded-2xl p-8 shadow-md border border-gray-100">
              <h3 className="text-xl font-semibold text-gray-900 mb-6">Informasi Kontak</h3>
              
              <div className="space-y-5">
                <div className="flex items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">Alamat</div>
                    <p className="text-sm text-gray-600">Brajan, Pugeran, Kec. Karangdowo, Kabupaten Klaten, Jawa Tengah 57464</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">Jam Operasional</div>
                    <p className="text-sm text-gray-600">Senin - Sabtu: 07.00 - 18.00 WIB</p>
                    <p className="text-sm text-gray-600">Minggu: 09.00 - 18.00 WIB</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">Telepon</div>
                    <a href="tel:+62895338139977" className="text-sm text-blue-600 hover:text-blue-700">
                      0895-3381-3997-7
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">Email</div>
                    <a href="mailto:yezlaundry@gmail.com" className="text-sm text-blue-600 hover:text-blue-700">
                      yezlaundry@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-50 rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <div className="font-medium text-gray-900 mb-1">WhatsApp</div>
                    <a 
                      href="https://wa.me/62895338139977" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-sm text-blue-600 hover:text-blue-700"
                    >
                      Chat via WhatsApp
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-100">
                <a
                  href="https://maps.app.goo.gl/E1QLi6QzSicYBSFA7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full bg-blue-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-map-pin-line mr-2"></i>
                  Buka di Google Maps
                </a>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3953.844448842374!2d110.57875631477603!3d-7.709772994410789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a44ec59e7e019%3A0x5a6e7b0c8d9e0f1a!2sBrajan%2C%20Pugeran%2C%20Kec.%20Karangdowo%2C%20Kabupaten%20Klaten%2C%20Jawa%20Tengah%2057464!5e0!3m2!1sid!2sid!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="YEZ Laundry Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://readdy.ai/api/search-image?query=abstract%20clean%20laundry%20pattern%20with%20fresh%20white%20clothes%20bubbles%20water%20droplets%20soft%20fabric%20textures%20on%20light%20blue%20white%20background%20minimal%20modern%20design%20emphasizing%20freshness%20cleanliness&width=1920&height=600&seq=ctabg1&orientation=landscape" 
            alt="Background Pattern"
            className="w-full h-full object-cover object-top"
          />
        </div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Siap Mencoba Layanan Laundry Terbaik?
          </h2>
          <p className="text-lg text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed">
            Percayakan kebersihan pakaian Anda kepada YEZ Laundry. Hubungi kami sekarang dan nikmati layanan laundry profesional dengan harga terjangkau!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/62895338139977?text=Halo%20YEZ%20Laundry%2C%20saya%20ingin%20memesan%20layanan%20laundry"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-blue-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              Pesan via WhatsApp
            </a>
            <a
              href="tel:+62895338139977"
              className="bg-transparent text-white px-8 py-4 rounded-full text-base font-semibold border-2 border-white hover:bg-white/10 transition-all whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              Telepon Sekarang
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
